import { render, staticRenderFns } from "./SimilarAnnotation.vue?vue&type=template&id=172ff4b9&scoped=true"
import script from "./SimilarAnnotation.vue?vue&type=script&lang=js"
export * from "./SimilarAnnotation.vue?vue&type=script&lang=js"
import style0 from "./SimilarAnnotation.vue?vue&type=style&index=0&id=172ff4b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172ff4b9",
  null
  
)

export default component.exports